// 🧱 B370 (AI_156) — NENHUM PROBLEMA DE VERIFICAÇÃO DESENHA COMO OBJETO
// ─────────────────────────────────────────────────────────────
// O painel de verificação do laudo desenhava cada item de `problemas` direto
// como filho do React. O backend normaliza os itens do auditor para TEXTO, mas
// o hard-block determinístico de placeholder injeta um OBJETO no array depois
// dessa normalização — e React objeto-como-filho é erro #31, que sem boundary
// apagava a tela inteira (tela branca de 29-30/10/2026, laudo de Situação
// Especial com "[COMPLETAR]").
//
// O conserto da origem é no backend (injetar texto). Esta função é a segunda
// camada: qualquer item, de qualquer formato, vira uma linha legível. Em tela
// clínica, uma frase imperfeita é sempre melhor que a interface sumir.
// ─────────────────────────────────────────────────────────────

type ItemProblema =
  | string
  | number
  | {
      regra?: number | string | null;
      severidade?: string | null;
      tipo?: string | null;
      descricao?: string | null;
      detalhe?: string | null;
      correcao?: string | null;
      campo?: string | null;
      citacao?: string | null;
      frase_literal?: string | null;
    }
  | null
  | undefined;

/** Uma linha legível para qualquer formato de item de verificação. */
export function textoDoProblema(item: ItemProblema): string {
  if (item === null || item === undefined) return "";
  if (typeof item === "string") return item;
  if (typeof item !== "object") return String(item);

  const partes: string[] = [];
  if (item.regra !== undefined && item.regra !== null && item.regra !== "") {
    partes.push(`Regra ${item.regra}`);
  }
  if (item.severidade) partes.push(`[${item.severidade}]`);

  const corpo =
    item.descricao || item.detalhe || item.correcao ||
    (item.campo ? `Campo ${item.campo}` : "") || item.tipo || "";
  if (corpo) partes.push(String(corpo));

  const citacao = item.citacao || item.frase_literal;
  if (citacao) partes.push(`Citação: ${citacao}`);

  if (partes.length > 0) return partes.join(" — ");
  try {
    return JSON.stringify(item);
  } catch {
    return "Item de verificação não legível";
  }
}

/** Lista saneada: sem vazios, tudo string. */
export function textosDosProblemas(itens: unknown): string[] {
  if (!Array.isArray(itens)) return [];
  return itens.map((i) => textoDoProblema(i as ItemProblema)).filter((s) => s.length > 0);
}
